import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import {
  Container,
  TextField,
  Typography,
} from '@mui/material';
import {
  LoginContainer,
  LoginPaper,
  FormContainer,
  StyledLink,
  BackgroundContainer,
  StyledAlert,
  LoginButton,
  Logo
} from './LoginPage.styles';

import LoginBackground from './LoginBackground';

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const { login, passwordReset } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const success = await login(email, password);
    if (success) {
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    } else {
      setError('Failed to log in');
    }
  };

  const handlePasswordReset = async () => {
    const success = await passwordReset(email);

    if (success) {
      setConfirmation('Password reset email sent.');
    } else {
      setError('Failed to send password reset request.');
    }
  };

  return (
    <BackgroundContainer>
      <LoginBackground /> {}
      <Container component="main" maxWidth="xs" sx={{ position: 'relative', zIndex: 1 }}>
        <LoginContainer>
          <LoginPaper elevation={3}>
            <Logo>
                <img src={'./Icons/legal-demo-Logo-black.png'} alt="AKINI LEGAL" style={{ width: '250px', objectFit: 'contain' }} />
            </Logo>
            {error && <StyledAlert data-testid="error-message" severity="error">{error}</StyledAlert>}
            {confirmation && <StyledAlert severity="success">{confirmation}</StyledAlert>}

            <FormContainer onSubmit={handleSubmit}>
              <TextField
                margin="normal"
                required
                fullWidth
                label="Email Address"
                value={email}
                data-testid="username"
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                label="Password"
                type="password"
                data-testid="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <LoginButton type="submit" data-testid="submit" variant="contained">
                Login
              </LoginButton>
              <Typography variant="body2" align="center">
                <StyledLink>
                  <Link
                    data-testid="forgot-password"
                    onClick={handlePasswordReset}
                    style={{ cursor: 'pointer' }}
                  >
                    Forgot Password
                  </Link>
                </StyledLink>
              </Typography>
            </FormContainer>
          </LoginPaper>
        </LoginContainer>
      </Container>
    </BackgroundContainer>
  );
};
